import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import PropertyTypeSelector from '../components/PropertyTypeSelector'

export default connect(
  createStructuredSelector<ApplicationState, IGlobalConfigurationState>({
    configuration: selectConfiguration(),
  }),
)(PropertyTypeSelector)
